import { parseUserRole } from '@app/components/UsageLimitationBanner/utils/parseUserRole'
import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ProAiWordsAutomationMetric = lazy(() =>
  import('./ProAiWordsAutomationMetric').then((m) => ({ default: m.ProAiWordsAutomationMetric })),
)

/**
 * `<pro-ai-words-meter>` web component — thin bridge for Twig.
 *
 * Only `team-uuid` and `project-id` are required. React owns the full cell:
 * RTK-backed meter, eligible upsell tag, and legacy fallback help popover.
 */
class ProAiWordsMeterWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['team-uuid', 'project-id', 'user-role', 'plan-expiration-date', 'only-paid-ai-words']
  }

  override render() {
    const userRole = parseUserRole(this.prop('user-role'))

    return (
      <AppProviders>
        <ProAiWordsAutomationMetric
          teamUuid={this.prop('team-uuid')}
          projectId={this.prop('project-id')}
          userRole={userRole}
          planExpirationDate={this.getAttribute('plan-expiration-date') || undefined}
          onlyPaidAiWords={this.getAttribute('only-paid-ai-words') === 'true'}
        />
      </AppProviders>
    )
  }
}

customElements.define('pro-ai-words-meter', ProAiWordsMeterWebComponent)

export { ProAiWordsMeterWebComponent }
